export const MAX_VIDEO_TITLE_LENGTH = 100;
